import './GmapPricingTable.scss'
import CorporatePricingTableForm from '../../../features/corporatePricing/corporatePricingTable/CorporatePricingTableForm'

const CorporatePricingTable = () => {
  return (
    <CorporatePricingTableForm />
  )
}

export default CorporatePricingTable